import axios from "axios";

// Development: http://localhost:5000/api
// Production: https://api.saidqodirxon.uz/api
const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://api.saidqodirxon.uz/api";

const UPLOAD_BASE_URL =
  process.env.REACT_APP_UPLOAD_URL || "https://api.saidqodirxon.uz";

const api = axios.create({
  baseURL: API_BASE_URL,
});

export const getProfile = () => api.get("/profile");
export const getProjects = () => api.get("/projects");
export const getSkills = () => api.get("/skills");
export const getResume = () => api.get("/resume");
export const getBlogs = () => api.get("/blogs");
export const getBlogBySlug = (slug) => api.get(`/blogs/${slug}`);
export const sendContact = (data) => api.post("/contact", data);
export const incrementProjectView = (id) => api.post(`/projects/${id}/view`);
export const incrementBlogView = (id, deviceId) =>
  api.post(`/blogs/${id}/view`, { deviceId });
export const toggleBlogLike = (id, deviceId) =>
  api.post(`/blogs/${id}/like`, { deviceId });

export const getImageURL = (path) => {
  if (!path) return null;

  // Agar path allaqachon to'liq URL bo'lsa
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  // Path ni tozalash
  const cleanPath = path.replace(/^\/+/, "").replace(/^uploads\//, "");

  // To'liq URL yaratish
  const fullUrl = `${UPLOAD_BASE_URL}/uploads/${cleanPath}`;

  console.log("Generated image URL:", fullUrl);
  return fullUrl;
};

export { API_BASE_URL, UPLOAD_BASE_URL };

export default api;
